/* VastraGharr Luxe — "Complete the look" bundle (<vg-bundle>, snippets/vg-bundle.liquid)
 * - Items come from the product metafield custom.complete_the_look (rendered in Liquid) or, when that is empty, from
 *   the same section rendered through /recommendations/products (intent=complementary, then related when the block's
 *   source is "related"). Results are inserted only when that cannot shift visible content (CLS): below or above the
 *   viewport, or right after a tap / key press.
 * - Checkbox + size select per item, live total, one "Add selected to bag" button: POST items[] to /cart/add.js with
 *   Dawn's cart drawer sections, then cart-drawer.renderContents() (opens + refreshes the drawer) and a pubsub
 *   cartUpdate (source "vg-bundle"). The button carries data-vg-fly-source for vg-cart.js's fly-to-bag animation.
 * - Never initialises inside Dawn's quick add modal; safe across theme editor section reloads.
 */
(function () {
  'use strict';

  if (!window.customElements || customElements.get('vg-bundle')) return;

  var ADDED_MS = 1600;

  function formatMoney(cents, format) {
    var amount = Number(cents) || 0;
    var template = format || '{{amount}}';
    var match = template.match(/\{\{\s*(\w+)\s*\}\}/);

    function delimit(precision, thousands, decimal) {
      var fixed = (amount / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }

    var value;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals':
        value = delimit(0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = delimit(2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = delimit(0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = delimit(2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = delimit(0, ' ', ',');
        break;
      case 'amount_with_space_separator':
        value = delimit(2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = delimit(2, ' ', '.');
        break;
      default:
        value = delimit(2, ',', '.');
    }
    return match ? template.replace(match[0], value) : value;
  }

  function errorText() {
    return (
      (window.cartStrings && window.cartStrings.error) || 'There was an error while updating your bag. Please try again.'
    );
  }

  function fetchResults(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (text) {
        if (!text) return '';
        var results = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-vg-bundle-results]');
        if (!results || Number(results.dataset.count) === 0) return '';
        return results.innerHTML.trim();
      })
      .catch(function () {
        return '';
      });
  }

  function onIdle(callback) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 2500 });
    } else {
      window.setTimeout(callback, 600);
    }
  }

  /* y position where the (hidden) element will open up */
  function insertionY(el) {
    var ref = el.previousElementSibling;
    while (ref && ref.offsetParent === null && ref.previousElementSibling) ref = ref.previousElementSibling;
    var rect = (ref || el.parentElement || el).getBoundingClientRect();
    return ref ? rect.bottom : rect.top;
  }

  /* Run `callback` when growing `el` cannot move visible content: the spot is below or above the viewport
     (scroll anchoring keeps the view still), or within the 500 ms after a discrete input that CLS ignores. */
  function whenSafe(el, callback) {
    var y = insertionY(el);
    if (el.offsetParent !== null || y >= window.innerHeight || y <= 0) {
      callback();
      return;
    }
    var done = false;
    var frame = null;
    function cleanup() {
      window.removeEventListener('pointerdown', run, true);
      window.removeEventListener('keydown', run, true);
      window.removeEventListener('scroll', onScroll);
    }
    function run() {
      if (done) return;
      done = true;
      cleanup();
      callback();
    }
    function onScroll() {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = null;
        var top = insertionY(el);
        if (top >= window.innerHeight || top <= 0) run();
      });
    }
    window.addEventListener('pointerdown', run, true);
    window.addEventListener('keydown', run, true);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  customElements.define(
    'vg-bundle',
    class VgBundle extends HTMLElement {
      connectedCallback() {
        if (this.vgReady || this.closest('quick-add-modal')) return;
        this.vgReady = true;

        this.list = this.querySelector('[data-vg-bundle-list]');
        this.button = this.querySelector('[data-vg-bundle-add]');
        this.totalEl = this.querySelector('[data-vg-bundle-total]');
        this.countEl = this.querySelector('[data-vg-bundle-count]');
        this.errorEl = this.querySelector('[data-vg-bundle-error]');
        this.statusEl = this.querySelector('[data-vg-bundle-status]');
        this.format = this.dataset.moneyFormat;

        this.onChange = this.onChange.bind(this);
        this.onAdd = this.onAdd.bind(this);
        this.addEventListener('change', this.onChange);
        if (this.button) this.button.addEventListener('click', this.onAdd);

        this.refresh();
        if (this.dataset.url && !this.classList.contains('has-items')) {
          var self = this;
          onIdle(function () {
            if (self.isConnected) self.load();
          });
        }
      }

      disconnectedCallback() {
        this.vgReady = false;
        this.removeEventListener('change', this.onChange);
        if (this.button) this.button.removeEventListener('click', this.onAdd);
        window.clearTimeout(this.addedTimer);
      }

      load() {
        var url = this.dataset.url;
        var related = this.dataset.source === 'related';
        var self = this;
        fetchResults(url + '&intent=complementary')
          .then(function (html) {
            return html || (related ? fetchResults(url + '&intent=related') : '');
          })
          .then(function (html) {
            if (!html || !self.isConnected || !self.list) return;
            whenSafe(self, function () {
              if (!self.isConnected) return;
              self.list.innerHTML = html;
              self.classList.add('has-items');
              var note = self.querySelector('[data-vg-bundle-editor-note]');
              if (note) note.remove();
              self.hidden = false;
              self.refresh();
            });
          });
      }

      items() {
        return Array.prototype.slice.call(this.querySelectorAll('[data-vg-bundle-item]'));
      }

      variantField(item) {
        return item.querySelector('[data-vg-bundle-variant]');
      }

      variantPrice(item) {
        var field = this.variantField(item);
        if (!field) return 0;
        var source = field.tagName === 'SELECT' ? field.options[field.selectedIndex] : field;
        return source ? Number(source.getAttribute('data-price')) || 0 : 0;
      }

      onChange(event) {
        var item = event.target.closest('[data-vg-bundle-item]');
        if (!item) return;
        /* Keep the change from reaching Dawn's handlers higher up (variant-selects / cart-items listen to change). */
        event.stopPropagation();
        if (event.target.matches('[data-vg-bundle-check]')) {
          item.classList.toggle('is-checked', event.target.checked);
        } else if (event.target.matches('[data-vg-bundle-variant]')) {
          var price = item.querySelector('[data-vg-bundle-price]');
          if (price) price.textContent = formatMoney(this.variantPrice(item), this.format);
        }
        this.refresh();
      }

      selected() {
        var self = this;
        return this.items().filter(function (item) {
          var check = item.querySelector('[data-vg-bundle-check]');
          var field = self.variantField(item);
          return check && check.checked && field && field.value;
        });
      }

      refresh() {
        var all = this.items();
        var selected = this.selected();
        var self = this;
        var total = selected.reduce(function (sum, item) {
          return sum + self.variantPrice(item);
        }, 0);
        all.forEach(function (item) {
          var check = item.querySelector('[data-vg-bundle-check]');
          item.classList.toggle('is-checked', Boolean(check && check.checked));
        });
        if (this.totalEl) this.totalEl.textContent = formatMoney(total, this.format);
        if (this.countEl) this.countEl.textContent = '(' + selected.length + ')';
        this.classList.toggle('has-items', all.length > 0);
        if (this.button && !this.busy) {
          if (selected.length) {
            this.button.removeAttribute('disabled');
          } else {
            this.button.setAttribute('disabled', '');
          }
        }
      }

      setBusy(busy) {
        this.busy = busy;
        if (!this.button) return;
        this.button.classList.toggle('is-loading', busy);
        this.button.classList.toggle('loading', busy);
        if (busy) {
          this.button.setAttribute('aria-disabled', 'true');
        } else {
          this.button.removeAttribute('aria-disabled');
        }
        var spinner = this.button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.toggle('hidden', !busy);
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message || '';
        this.errorEl.hidden = !message;
      }

      markAdded(count) {
        var button = this.button;
        if (!button) return;
        window.clearTimeout(this.addedTimer);
        button.classList.add('is-added');
        this.addedTimer = window.setTimeout(function () {
          button.classList.remove('is-added');
        }, ADDED_MS);
        if (this.statusEl) {
          this.statusEl.textContent = count === 1 ? 'Added 1 piece to your bag' : 'Added ' + count + ' pieces to your bag';
        }
      }

      onAdd(event) {
        event.preventDefault();
        if (this.busy) return;
        var selected = this.selected();
        if (!selected.length) return;
        var self = this;
        var items = selected.map(function (item) {
          return { id: Number(self.variantField(item).value), quantity: 1 };
        });

        this.showError('');
        this.setBusy(true);

        var drawer = document.querySelector('cart-drawer');
        var useDrawer =
          drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function';
        var body = { items: items };
        if (useDrawer) {
          body.sections = drawer.getSectionsToRender().map(function (section) {
            return section.id;
          });
          body.sections_url = window.location.pathname;
          if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(this.button);
        }

        var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
        fetch(addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(body),
        })
          .then(function (response) {
            return response.json().then(function (data) {
              return { ok: response.ok, data: data || {} };
            });
          })
          .then(function (result) {
            var data = result.data;
            if (!result.ok || data.status) throw new Error(data.description || data.message || errorText());

            self.markAdded(items.length);

            if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              window.publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'vg-bundle',
                productVariantId: items[0].id,
                cartData: data,
              });
            }

            if (useDrawer && data.sections) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(data);
            } else {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }
          })
          .catch(function (error) {
            self.showError((error && error.message) || errorText());
          })
          .finally(function () {
            self.setBusy(false);
            self.refresh();
          });
      }
    }
  );
})();
